import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Chip,
  Card,
  CardContent,
  Stack,
  Box,
  CardHeader,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Alert,
  Checkbox,
  Switch,
} from "@mui/material";
import getAllStore from "../../api/store/getAllStore";
import { useTheme } from "@mui/material/styles";
import getTablesWithTimer from "../../api/store/getTableWithTimer";
import { CITIES } from "../../data/CITIES";
import TableDialog from "../../component/management/TableDialog";
import updateTableStatus from "../../api/store/updateTableStatus";
import { AuthContext } from "../../context/AuthContext";
import ConfirmDialog from "../../component/ConfirmDialog";
import removeReservation from "../../api/store/removeReservation";
import AddReservationDialog from "../../component/management/AddReservationDialog";
import ReservationTimeline from "../../component/ReservationTimeline";
function TablePage() {
  const [open, setOpen] = useState(false);
  const [selectedButton, setSelectedButton] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [filteredStores, setFilteredStores] = useState([]);
  const [stores, setStores] = useState([]);
  const [tables, setTables] = useState([]); // Initialize with your store data
  const [selectedStatus, setSelectedStatus] = React.useState("reservation");
  const [isAddReservationDialogOpen, setIsAddReservationDialogOpen] =
    useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [duration, setDuration] = useState({});
  const theme = useTheme();
  const [cities, setCities] = useState([]);
  const [error, setError] = useState(null);

  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmDialogFunc, setConfirmDialogFunc] = useState(null);

  const [showAlert, setShowAlert] = useState({});
  const [isSuccess, setIsSuccess] = useState({});
  const userContext = useContext(AuthContext);
  const status = {
    open: "open",
    close: "close",
    reservation: "reservation",
  };
  const pcStatusOptions = {
    idle: "正常",
    on: "開啟",
    off: "關閉",
  };

  const handleOpenConfirmDialog = (tableCode, startTime) => {
    const confirmFunction = () =>
      handleRemoveReservationClick(tableCode, startTime);

    setConfirmDialogFunc(() => confirmFunction);
    setConfirmDialog(true);
  };

  const handleRemoveReservationClick = (tableCode, startTime) => {
    const rr = async () => {
      try {
        const data = await removeReservation(tableCode,startTime);

        if (data.code === "000") {
          // Update the state to reflect the removal
          setTables((prevTables) =>
            prevTables.map((table) =>
              table.Code === tableCode
                ? {
                    ...table,
                    Reservations: table.Reservations.filter(
                      (res) => res.StartTime !== startTime
                    ),
                  }
                : table
            )
          );
        }
      } catch (err) {}
    };

    rr();
  };

  const handleStatusChange = (event, index) => {
    setSelectedTable(tables[index]);
    setShowAlert((prevState) => ({
      ...prevState,
      [index]: false,
    }));
    tables[index].Status = event.target.value;
    setSelectedStatus(event.target.value);
    setIsSuccess((prevState) => ({
      ...prevState,
      [index]: false,
    }));
  };

  const handlePcStatusChange = (event, index) => {
    setSelectedTable(tables[index]);
    setShowAlert((prevState) => ({
      ...prevState,
      [index]: false,
    }));
    tables[index].PcStatus = event.target.value;

    setIsSuccess((prevState) => ({
      ...prevState,
      [index]: false,
    }));
  };
  const handleTurnOnDoorChange = (event, index) => {
    setSelectedTable(tables[index]);
    setShowAlert((prevState) => ({
      ...prevState,
      [index]: false,
    }));

    tables[index].TurnOnDoor = !tables[index].TurnOnDoor;

    setIsSuccess((prevState) => ({
      ...prevState,
      [index]: false,
    }));
  };
  useEffect(() => {
    const fetchStores = async () => {
      try {
        const data = await getAllStore();

        var userStore = [];
        if (
          userContext.user.Role === "Moderator" ||
          userContext.user.Role === "Support"
        ) {
          data.stores.forEach((store) => {
            userContext.user.Permissions.forEach((p) => {
              if (store.Code === p.store) {
                userStore.push(store);
              }
            });
          });
          setStores(userStore);
        } else if (userContext.user.Role === "Admin") {
          setStores(data.stores);
        }
      } catch (err) {
        setError(err.message);
      }
    };

    if (stores) {
      fetchStores();
    }
  }, []);

  useEffect(() => {
    let tmpCity = {};
    let cityArray = [];
    for (var key in stores) {
      tmpCity[stores[key].City] = 1;
    }
    for (key in tmpCity) {
      cityArray.push(key);
    }

    cityArray.sort((a, b) => {
      return CITIES.indexOf(a) - CITIES.indexOf(b);
    });

    setCities(cityArray);
  }, [stores]);

  const fetchTables = async (store) => {
    try {
      const data = await getTablesWithTimer(store?.Code);

      if (data?.table) {
        // Sort the tables by their Code
        const sortedTables = data.table.sort((a, b) =>
          a.Code.localeCompare(b.Code)
        );
        setTables(sortedTables);

        // Update duration state

        if (data.timer) {
          const newDuration = {};
          sortedTables.forEach((table, _) => {
            // Map each duration to the corresponding table code

            newDuration[table.Code] = Math.round(data.timer[table.Code]) || 0;
          });

          setDuration(newDuration);
        }
      }
    } catch (err) {
      setError(err.message);
    }
  };
  const onStoreSelected = (store) => {
    fetchTables(store);
  };

  useEffect(() => {
    let tmpStores = [];
    stores.map((store, index) => {
      if (store.City === selectedButton) {
        tmpStores.push(store);
      }
    });

    setFilteredStores(tmpStores);
  }, [selectedButton]);
  const handleEditClick = (table, index) => {
    setShowAlert((prevState) => ({
      ...prevState,
      [index]: false,
    }));
    setSelectedTable(table);
    setOpen(true);
  };
  const handleConfirmClick = (index) => {
    const updateTable = async () => {
      try {
        const data = await updateTableStatus(
          tables[index].StoreCode,
          tables[index].Code,
          tables[index].Status,
          duration[tables[index].Code],
          tables[index].TurnOnDoor,
          tables[index].PcStatus
        );
        setShowAlert((prevState) => ({
          ...prevState,
          [index]: true,
        }));
        setIsSuccess((prevState) => ({
          ...prevState,
          [index]: true,
        }));
      } catch (err) {
        setShowAlert((prevState) => ({
          ...prevState,
          [index]: true,
        }));
        setIsSuccess((prevState) => ({
          ...prevState,
          [index]: false,
        }));
        setError(err.message);
      }
    };

    updateTable();
  };

  const handleDurationChange = (newValue, tableCode) => {
    if (typeof newValue === "number") {
      setDuration((prevDuration) => ({
        ...prevDuration,
        [tableCode]: Math.round(newValue),
      }));
    }
  };

  const durationFormat = (tableCode) => {
    const tableDuration = duration[tableCode];
    if (tableDuration === undefined || tableDuration === 0) {
      return "永久";
    }

    const hours = Math.floor(tableDuration / 60);
    const minutes = Math.round(tableDuration % 60);
    return `${hours}小時${minutes}分鐘`;
  };
  const handleAddReservation = (newReservation, tableCode) => {
    setTables((prevTables) =>
      prevTables.map((table) =>
        table.Code === tableCode
          ? {
              ...table,
              Reservations: [...table.Reservations, newReservation],
            }
          : table
      )
    );
  };
  return (
    <>
      <Box>
        {cities.map((label, index) => (
          <Chip
            key={index}
            label={label}
            // Set the variant based on the selected state
            variant={selectedButton === label ? "contained" : "contained"}
            // Set the click handler to update the selected button
            onClick={() => {
              setSelectedButton(label);
              setTables([]);
              setSelectedItem(null);
            }}
            sx={{
              margin: "3px",
              fontSize: "12pt",
              border: 0.5,
              backgroundColor:
                selectedButton === label
                  ? theme.palette.selected
                  : theme.palette.primary.main,
              color:
                selectedButton === label
                  ? theme.palette.text.selected
                  : "default",
              "&:focus": {
                backgroundColor: theme.palette.selected,
                color: theme.palette.text.selected,
              },
            }}
          ></Chip>
        ))}
        <Stack direction={"row"}>
          {filteredStores.map((store, index) => (
            <Button
              key={"card" + index}
              variant="contained"
              onClick={() => {
                setSelectedItem(index);
                onStoreSelected(store);
              }}
              sx={{
                marginTop: 1,
                marginRight: 1,
                backgroundColor:
                  selectedItem === index
                    ? theme.palette.selected
                    : "transparent",
                fontWeight: "bold",
                color: selectedItem === index ? "white" : "inherit",
              }}
            >
              {store.Name}
            </Button>
          ))}
        </Stack>
        <Box flexDirection={"row"}>
          {tables.map((table, index) => (
            
            <Card
              key={"card" + index}
              sx={{ marginTop: 1, marginRight: 1, minWidth: "150px" }}
            >
         
              <CardContent>
                <Stack direction={"row"}>
                  <Box minWidth={"70%"} flexDirection={"column"}>
                    <CardHeader
                      title={
                        <Stack
                          direction={"row"}
                          display={"flex"}
                          alignItems={"center"}
                        >
                          <Typography
                            align="left"
                            fontSize={18}
                            fontWeight={"bold"}
                          >
                            {`${table.Name} $${table.Price} `}
                          </Typography>{" "}
                          <FormControlLabel
                            value={table?.Status === "close"? "reservation":"close"}
                            control={
                              <Switch
                                color="success"
                                checked={table?.Status !== "close"}
                                onChange={(event) =>
                                  handleStatusChange(event, index)
                                }
                              />
                            }
                            label={table?.Status !== "close"? "可預約":"不可預約"}
                            labelPlacement="start"
                          ></FormControlLabel>
                        </Stack>
                      }
                      subheader={
                        <React.Fragment>
                          <Typography align="left">{table.Code}</Typography>
                        </React.Fragment>
                      }
                    />

                    {/* <RadioGroup
                      name="use-radio-group"
                      defaultValue="first"
                      value={table.Status || null}
                      onChange={(event) => handleStatusChange(event, index)}
                    >
                      <FormControlLabel
                        value={status.open}
                        label={
                          table.Status === status.open
                            ? "通電　時間:" + durationFormat(table.Code)
                            : "通電"
                        }
                        control={<Radio color="success" />}
                      ></FormControlLabel>

                      {table.Status === status.open && (
                        <Slider
                          value={duration[table.Code] || 0}
                          aria-label="Duration"
                          defaultValue={0}
                          getAriaValueText={() => durationFormat(table.Code)}
                          valueLabelFormat={() => durationFormat(table.Code)}
                          valueLabelDisplay="auto"
                          color="info"
                          marks
                          step={10}
                          min={0}
                          max={600}
                          sx={{ marginLeft: 2 }}
                          onChange={(event, newValue) =>
                            handleDurationChange(newValue, table.Code)
                          }
                        />
                      )}
                      <FormControlLabel
                        value={status.close}
                        label={
                          table.Status === status.close
                            ? "斷電　時間:" + durationFormat(table.Code)
                            : "斷電"
                        }
                        control={<Radio color="error" />}
                      />
                      {table.Status === status.close && (
                        <Slider
                          value={duration[table.Code] || 0}
                          aria-label="Duration"
                          defaultValue={0}
                          getAriaValueText={() => durationFormat(table.Code)}
                          valueLabelFormat={() => durationFormat(table.Code)}
                          valueLabelDisplay="auto"
                          color="info"
                          marks
                          step={10}
                          min={0}
                          max={600}
                          sx={{ marginLeft: 2 }}
                          onChange={(event, newValue) =>
                            handleDurationChange(newValue, table.Code)
                          }
                        />
                      )}
                      <FormControlLabel
                        value={status.reservation}
                        label={"預約制"}
                        control={<Radio color="info" />}
                      />
                    </RadioGroup> */}
                    <Typography variant="body2">PC狀態:</Typography>
                    <RadioGroup
                      name={`pc-status-${index}`}
                      value={null || table.PcStatus}
                      onChange={(event) => handlePcStatusChange(event, index)}
                    >
                      {Object.entries(pcStatusOptions).map(([key, label]) => (
                        <FormControlLabel
                          key={key}
                          value={key}
                          control={<Radio color="warning" />}
                          label={label}
                        />
                      ))}
                    </RadioGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="warning"
                          checked={tables[index].TurnOnDoor || false}
                          onChange={(event) =>
                            handleTurnOnDoorChange(event, index)
                          }
                        />
                      }
                      label="門的開啟狀態"
                    />
                    <Stack direction={"column"}>
                      <ReservationTimeline
                        reservations={table.Reservations}
                        onCancelClicked={(startTime) => {
                          handleOpenConfirmDialog(table.Code, startTime);
                        }}
                      ></ReservationTimeline>
                      <Button
                        color="primary"
                        variant="contained"
                        sx={{ width: "30%", height: "40px", marginY: 2 }}
                        onClick={() => {
                          setSelectedTable(table); // Assuming `table` is the current item in your map function
                          setIsAddReservationDialogOpen(true);
                        }}
                      >
                        新增預約時間
                      </Button>

                      <Button
                        color="primary"
                        variant="contained"
                        sx={{ width: "10%", height: "40px", marginY: 2 }}
                        onClick={(event) => {
                          handleConfirmClick(index);
                        }}
                      >
                        儲存
                      </Button>
                    </Stack>
                  </Box>

                  <Button
                    color="primary"
                    variant="contained"
                    sx={{ height: "30px", marginTop: 3 }}
                    onClick={() => {
                      handleEditClick(table, index);
                    }}
                  >
                    編輯
                  </Button>
                </Stack>
                {showAlert[index] ? (
                  isSuccess[index] ? (
                    <Alert severity="success">更新成功!</Alert>
                  ) : (
                    <Alert severity="error">更新失敗，請重新再試</Alert>
                  )
                ) : null}
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
      <TableDialog
        tableData={selectedTable}
        open={open}
        setOpen={setOpen}
      ></TableDialog>
      <ConfirmDialog
        open={confirmDialog}
        title={"取消訂位"}
        content={"確定要取消目前的訂位嗎?"}
        onClose={() => {
          setConfirmDialog(false);
        }}
        confirmOnly={false}
        onConfirm={confirmDialogFunc}
      />
      <AddReservationDialog
        storeCode={selectedTable ? selectedTable.StoreCode : null}
        tableCode={selectedTable ? selectedTable.Code : null} // pass the selected table code
        onAddReservation={handleAddReservation}
        open={isAddReservationDialogOpen}
        onClose={() => setIsAddReservationDialogOpen(false)} // method to close the dialog
      />
    </>
  );
}

export default TablePage;
